/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Freiherr_Vom_Stein_Schule_Fulda5Inputs */

const en__field__enum_schoolname_freiherr_vom_stein_schule_fulda5 = /** @type {(inputs: _Field__Enum_Schoolname_Freiherr_Vom_Stein_Schule_Fulda5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulda`)
};

const de__field__enum_schoolname_freiherr_vom_stein_schule_fulda5 = /** @type {(inputs: _Field__Enum_Schoolname_Freiherr_Vom_Stein_Schule_Fulda5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freiherr-vom-Stein-Schule`)
};

/**
* | output |
* | --- |
* | "Fulda" |
*
* @param {_Field__Enum_Schoolname_Freiherr_Vom_Stein_Schule_Fulda5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_freiherr_vom_stein_schule_fulda5 = /** @type {((inputs?: _Field__Enum_Schoolname_Freiherr_Vom_Stein_Schule_Fulda5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Freiherr_Vom_Stein_Schule_Fulda5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_freiherr_vom_stein_schule_fulda5(inputs)
	return de__field__enum_schoolname_freiherr_vom_stein_schule_fulda5(inputs)
});
export { _field__enum_schoolname_freiherr_vom_stein_schule_fulda5 as "_field__enum_schoolName_Freiherr_vom_Stein_Schule_Fulda" }